import { snakeCase } from 'lodash';
import moment from 'moment';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DatePicker } from 'components/atoms/date-picker';
import { Radio } from 'components/atoms/radio';
import {
  Line,
  Lines,
} from 'components/organisms/tasks/criteria/date/components';
import { DateFieldFilterOperationType } from 'components/organisms/tasks/filters/date';
import { RangePickerMenuItem } from './range-picker-item';

interface Props {
  activeType: DateFieldFilterOperationType | null;
  type: DateFieldFilterOperationType;
  setDate: (day: moment.Moment) => void;
  date: moment.Moment;
}

export const absoluteRangePicker = ({
  type,
  activeType,
  setDate,
  date,
}: Props): JSX.Element => (
  <RangePickerMenuItem key={type} selected={type === activeType}>
    <Lines>
      <Line>
        <Radio checked={type === activeType} />
        <FormattedMessage
          id={`task_list.filters.${snakeCase(
            DateFieldFilterOperationType[type],
          )}`}
        />
      </Line>
      {type === activeType ? (
        <Line>
          <DatePicker
            autoFocus
            onChange={(_date) => (_date ? setDate(_date) : null)}
            value={date}
          />
        </Line>
      ) : null}
    </Lines>
  </RangePickerMenuItem>
);
